<template lang="html">
  <div class="nav">
    <!-- <div class="menuSelect"> -->
    <a-carousel autoplay>
      <img src="../assets/banner-1.jpg" alt=""  style="height:500px;"/>
      <img src="../assets/banner-3.jpg" alt="" style="height:500px;"/>
      <img src="../assets/banner-2.jpeg" alt="" style="height:500px;"/>
    </a-carousel>
      <a-dropdown>
        <a class="ant-dropdown-link" href="#"> {{menuTitle}} <a-icon type="down" /> </a>
        <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item key="0">全部分类</a-menu-item>
          <a-menu-item key="1">感冒用药</a-menu-item>
          <a-menu-item key="2">肠胃用药</a-menu-item>
          <a-menu-item key="3">儿科用药</a-menu-item>
          <a-menu-item key="4">妇科药品</a-menu-item>
          <!-- <a-menu-item key="5">医疗器械</a-menu-item> -->
        </a-menu>
      </a-dropdown>
    <!-- </div> -->
      <div class="centerBox">
        <div class="drugList" v-show="isShow0">
          <div class="goods" v-for="item in goodsList0" :key="item.id">
            <img alt="" :src="item.goodsPic" />
            <div class="goodsTitle">{{item.goodsName}}</div>
            <div class="isShow" @click="handleDrugDetails(item.id)">查看详情</div>
          </div>
        </div>
        <div class="drugList" v-show="isShow1">
          <div class="goods" v-for="item in goodsList1" :key="item.id">
            <img alt="" :src="item.goodsPic" />
            <div class="goodsTitle">{{item.goodsName}}</div>
            <div class="isShow" @click="handleDrugDetails(item.id)">查看详情</div>
          </div>
        </div>
        <div class="drugList" v-show="isShow2">
          <div class="goods" v-for="item in goodsList2" :key="item.id">
            <img alt="" :src="item.goodsPic" />
            <div class="goodsTitle">{{item.goodsName}}</div>
            <div class="isShow" @click="handleDrugDetails(item.id)">查看详情</div>
          </div>
        </div>
        <div class="drugList" v-show="isShow3">
          <div class="goods" v-for="item in goodsList3" :key="item.id">
            <img alt="" :src="item.goodsPic" />
            <div class="goodsTitle">{{item.goodsName}}</div>
            <div class="isShow" @click="handleDrugDetails(item.id)">查看详情</div>
          </div>
        </div>
        <div class="drugList" v-show="isShow4">
          <div class="goods" v-for="item in goodsList4" :key="item.id">
            <img alt="" :src="item.goodsPic" />
            <div class="goodsTitle">{{item.goodsName}}</div>
            <div class="isShow" @click="handleDrugDetails(item.id)">查看详情</div>
          </div>
        </div>
        <!-- <div class="drugList" v-show="isShow5">
          <div class="goods" v-for="item in goodsList5" :key="item.id">
            <img alt="" :src="item.goodsPic" />
            <div class="goodsTitle">{{item.goodsName}}</div>
            <div class="isShow" @click="handleDrugDetails(item.id)">查看详情</div>
          </div>
        </div> -->
      </div>
      <div class="footer">
        Copyright © All Rights Reserved.  浙江和云网络科技有限公司 备案号：浙ICP备18024148号-2
      </div>
  </div>
</template>

<script>
export default {
  name: 'informationService',
  components: {
  },
  data(){
    return{
      isShow0: true,
      isShow1: false,
      isShow2: false,
      isShow3: false,
      isShow4: false,
      // isShow5: false,
      menuTitle: "全部分类",
      goodsList0: [
        {
          id:1,
          goodsPic: require('../assets/drug-1.jpg'),
          goodsName: "感冒灵颗粒"
        },{
          id:2,
          goodsPic: require('../assets/drug-2.png'),
          goodsName: "板蓝根颗粒"
        },{
          id:3,
          goodsPic: require('../assets/drug-3.png'),
          goodsName: "咽炎片"
        },{
          id:4,
          goodsPic: require('../assets/drug-4.png'),
          goodsName: "感冒清热颗粒"
        },{
          id:5,
          goodsPic: require('../assets/drug-5.png'),
          goodsName: "夏桑菊颗粒"
        },{
          id:6,
          goodsPic: require('../assets/drug-6.png'),
          goodsName: "健胃消食片"
        },{
          id:7,
          goodsPic: require('../assets/drug-7.png'),
          goodsName: "肠炎宁片"
        },{
          id:8,
          goodsPic: require('../assets/drug-8.png'),
          goodsName: "奥美拉唑肠溶胶囊"
        },{
          id:9,
          goodsPic: require('../assets/drug-9.png'),
          goodsName: "养胃舒胶囊"
        },{
          id:10,
          goodsPic: require('../assets/drug-10.png'),
          goodsName: "铝碳酸镁片"
        },{
          id:11,
          goodsPic: require('../assets/drug-11.png'),
          goodsName: "维生素AD滴剂"
        },{
          id:12,
          goodsPic: require('../assets/drug-12.png'),
          goodsName: "丁桂儿脐贴"
        },{
          id:13,
          goodsPic: require('../assets/drug-13.png'),
          goodsName: "葡萄糖酸锌口服溶液"
        },{
          id:14,
          goodsPic: require('../assets/drug-14.png'),
          goodsName: "三公仔"
        },{
          id:15,
          goodsPic: require('../assets/drug-15.png'),
          goodsName: "布洛芬混悬液"
        },{
          id:16,
          goodsPic: require('../assets/drug-16.png'),
          goodsName: "洁尔阴洗液"
        },{
          id:17,
          goodsPic: require('../assets/drug-17.png'),
          goodsName: "硝呋太尔制霉素阴道软胶囊"
        },{
          id:18,
          goodsPic: require('../assets/drug-18.png'),
          goodsName: "乌鸡白凤丸(水蜜丸)"
        },{
          id:19,
          goodsPic: require('../assets/drug-19.png'),
          goodsName: "妇科千金片"
        },{
          id:20,
          goodsPic: require('../assets/drug-20.png'),
          goodsName: "妇炎康片"
        }
        // ,{
        //   id:21,
        //   goodsPic: require('../assets/drug-21.png'),
        //   goodsName: "欧姆龙电子血压计"
        // },{
        //   id:22,
        //   goodsPic: require('../assets/drug-22.png'),
        //   goodsName: "欧姆龙电子血糖仪"
        // },{
        //   id:23,
        //   goodsPic: require('../assets/drug-23.png'),
        //   goodsName: "鱼跃电子血氧仪"
        // },{
        //   id:24,
        //   goodsPic: require('../assets/drug-24.png'),
        //   goodsName: "儿童电子温度计"
        // },{
        //   id:25,
        //   goodsPic: require('../assets/drug-25.png'),
        //   goodsName: "胎心检测仪"
        // }
      ],
      goodsList1: [
        {
          id:1,
          goodsPic: require('../assets/drug-1.jpg'),
          goodsName: "感冒灵颗粒"
        },{
          id:2,
          goodsPic: require('../assets/drug-2.png'),
          goodsName: "板蓝根颗粒"
        },{
          id:3,
          goodsPic: require('../assets/drug-3.png'),
          goodsName: "咽炎片"
        },{
          id:4,
          goodsPic: require('../assets/drug-4.png'),
          goodsName: "感冒清热颗粒"
        },{
          id:5,
          goodsPic: require('../assets/drug-5.png'),
          goodsName: "夏桑菊颗粒"
        }
      ],
      goodsList2: [
        {
          id:6,
          goodsPic: require('../assets/drug-6.png'),
          goodsName: "健胃消食片"
        },{
          id:7,
          goodsPic: require('../assets/drug-7.png'),
          goodsName: "肠炎宁片"
        },{
          id:8,
          goodsPic: require('../assets/drug-8.png'),
          goodsName: "奥美拉唑肠溶胶囊"
        },{
          id:9,
          goodsPic: require('../assets/drug-9.png'),
          goodsName: "养胃舒胶囊"
        },{
          id:10,
          goodsPic: require('../assets/drug-10.png'),
          goodsName: "铝碳酸镁片"
        }
      ],
      goodsList3: [
        {
          id:11,
          goodsPic: require('../assets/drug-11.png'),
          goodsName: "维生素AD滴剂"
        },{
          id:12,
          goodsPic: require('../assets/drug-12.png'),
          goodsName: "丁桂儿脐贴"
        },{
          id:13,
          goodsPic: require('../assets/drug-13.png'),
          goodsName: "葡萄糖酸锌口服溶液"
        },{
          id:14,
          goodsPic: require('../assets/drug-14.png'),
          goodsName: "三公仔"
        },{
          id:15,
          goodsPic: require('../assets/drug-15.png'),
          goodsName: "布洛芬混悬液"
        }
      ],
      goodsList4: [
        {
          id:16,
          goodsPic: require('../assets/drug-16.png'),
          goodsName: "洁尔阴洗液"
        },{
          id:17,
          goodsPic: require('../assets/drug-17.png'),
          goodsName: "硝呋太尔制霉素阴道软胶囊"
        },{
          id:18,
          goodsPic: require('../assets/drug-18.png'),
          goodsName: "乌鸡白凤丸(水蜜丸)"
        },{
          id:19,
          goodsPic: require('../assets/drug-19.png'),
          goodsName: "妇科千金片"
        },{
          id:20,
          goodsPic: require('../assets/drug-20.png'),
          goodsName: "妇炎康片"
        }
      ],
      // goodsList5: [
      //   {
      //     id:21,
      //     goodsPic: require('../assets/drug-21.png'),
      //     goodsName: "欧姆龙电子血压计"
      //   },{
      //     id:22,
      //     goodsPic: require('../assets/drug-22.png'),
      //     goodsName: "欧姆龙电子血糖仪"
      //   },{
      //     id:23,
      //     goodsPic: require('../assets/drug-23.png'),
      //     goodsName: "鱼跃电子血氧仪"
      //   },{
      //     id:24,
      //     goodsPic: require('../assets/drug-24.png'),
      //     goodsName: "儿童电子温度计"
      //   },{
      //     id:25,
      //     goodsPic: require('../assets/drug-25.png'),
      //     goodsName: "胎心检测仪"
      //   }
      // ],
    }
  },
  methods: {
    handleMenuClick({key}) {
      const menuId = `${key}`;
      if(menuId == 1){
        this.menuTitle = "感冒用药"
        this.isShow0 = false;
        this.isShow1 = true;
        this.isShow2 = false;
        this.isShow3 = false;
        this.isShow4 = false;
        this.isShow5 = false;
      }else if(menuId == 2){
        this.menuTitle = "肠胃用药"
        this.isShow0 = false;
        this.isShow1 = false;
        this.isShow2 = true;
        this.isShow3 = false;
        this.isShow4 = false;
        this.isShow5 = false;
      }else if(menuId == 3){
        this.menuTitle = "儿科用药"
        this.isShow0 = false;
        this.isShow1 = false;
        this.isShow2 = false;
        this.isShow3 = true;
        this.isShow4 = false;
        this.isShow5 = false;
      }else if(menuId == 4){
        this.menuTitle = "妇科药品"
        this.isShow0 = false;
        this.isShow1 = false;
        this.isShow2 = false;
        this.isShow3 = false;
        this.isShow4 = true;
        this.isShow5 = false;
      }
      // else if(menuId == 5){
      //   this.menuTitle = "医疗器械类"
      //   this.isShow0 = false;
      //   this.isShow1 = false;
      //   this.isShow2 = false;
      //   this.isShow3 = false;
      //   this.isShow4 = false;
      //   this.isShow5 = true;
      // }
      else {
        this.menuTitle = "全部分类"
        this.isShow0 = true;
        this.isShow1 = false;
        this.isShow2 = false;
        this.isShow3 = false;
        this.isShow4 = false;
        this.isShow5 = false;
      }
    },
    handleDrugDetails(id){
      // console.log(id)
      this.$router.push({name:'drugDetails', params:{ drugId:id }})
    }
  },
}
</script>

<style lang="scss" scoped>
.ant-carousel{
  margin: 20px auto;
  text-align: center;
  width: 1200px;
  height: auto;
}
.ant-carousel >>> .slick-slide {
  text-align: center;
  height: auto;
  line-height: auto;
  // background: #364d79;
  overflow: hidden;
  img{
    vertical-align: middle;
    margin: 0 auto;
    width: 760px;
    height: auto;
  }
}
.nav{
  width: 1220px;
  margin: 20px auto;
  .centerBox{

    .drugList{
      width:1220px;
      margin: 20px auto;
      .goods{
        width: 290px;
        height: 400px;
        float: left;
        background: #FFF;
        transition: all .5s;
        // margin-bottom: 10px;
        margin-right: 15px;
        text-align: center;
        img{
          width: 206px;
          height: 206px;
          margin-top: 40px;
        }
        .goodsTitle{
          line-height: 1.2;
          font-size: 18px;
          font-weight: 800;
          color: #424242;
          margin: 20px auto;
          padding: 0 14px;
          text-align: center;
          overflow: hidden;
        }
        .isShow{
          display: none;
          width: 100px;
          height: 30px;
          line-height: 30px;
          margin: 40px auto;
          border: 1px solid #e1e1e1;
          border-radius: 4px;
          font-size: 12px;
          color: #646464;
          cursor: pointer;
          background-color: #f9f9f9;
          background-image: linear-gradient(180deg,#fff,#f9f9f9);
        }
        .isShow:hover{
          background: #f9f9f9;
        }
      }
      .goods:hover{
        box-shadow: 0px 0px 30px #CCC;
        transform: scale(1.1);
        .isShow{
          display: block;
        }
      }
    }
  }
}
.footer{
  background: 0;
  width: 100%;
  height: 200px;
  line-height: 200px;
  color: #757575;
  font-size: 12px;
  text-align: center;
}
</style>
